// extracted by mini-css-extract-plugin
module.exports = {"error":"AuthenticationGate_error__yTkYa"};